import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    allowProps: true,
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#00a5cd',
                secondary: '#9ad35e',
                accent: '#fff',
                accent2: '#000',
                rowQuestion: '#fff',
                rowReply: '#eae8e0',
                rowDivider: '#d5d2d0',
                stepperBackground: '#55cfed',
                error: '#F4511E',
                warning: '#ff9800',
                info: '#3b65a5',
                success: '#66bb6a',
            },
        },
    },
});
